const { default: axiosIns } = require('@/libs/axios')

const CatalogsService = {
  // GET - CatalogApiController
  async getCatalogs(accountId) {
    return axiosIns.get(`/catalogs?accountId=${accountId}`).then(response => response.data)
  },
  async getCatalog(catalogId, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}?accountId=${accountId}`).then(response => response.data)
  },
  async getCatalogItems(catalogId, page, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/items?accountId=${accountId}&page=${page}`).then(response => response.data)
  },
  async getCatalogLogs(catalogId, page, perPage, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/logs?page=${page}&perPage=${perPage}&accountId=${accountId}`).then(response => response.data)
  },
  async searchCatalogItems(catalogId, query, accountId) {
    return axiosIns
      .get(`/adgroups/searchcatalogitems?accountId=${accountId}`, {
        params: {
          catalogId,
          term: query,
        },
      })
      .then(response => response.data)
  },
  async searchCatalogBrands(catalogId, name, accountId) {
    return axiosIns
      .get(`/catalogs/${catalogId}/brands?accountId=${accountId}`, {
        params: {
          name,
        },
      })
      .then(response => response.data)
  },
  async searchCatalogCategories(catalogId, name, accountId) {
    return axiosIns
      .get(`/catalogs/${catalogId}/categories?accountId=${accountId}`, {
        params: {
          name,
        },
      })
      .then(response => response.data)
  },
  async getCatalogSettings(catalogId, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/settings?accountId=${accountId}`).then(response => response.data)
  },
  async getSharedCatalogs(accountId) {
    return axiosIns.get(`/catalogs/shared?accountId=${accountId}`).then(response => response.data)
  },
  // POST - CatalogApiController
  async createCatalog(catalog, accountId) {
    return axiosIns.post(`/catalogs?accountId=${accountId}`, catalog).then(response => response.data)
  },
  async getCatalogItemDetails(catalogId, filter, accountId) {
    return axiosIns.post(`/catalogs/${catalogId}/items/details?accountId=${accountId}`, filter).then(response => response.data)
  },
  // PUT - CatalogApiController
  async updateCatalog(catalog, accountId) {
    return axiosIns.put(`/catalogs/${catalog.encodedId}?accountId=${accountId}`, catalog).then(response => response.data)
  },
  // DELETE - CatalogApiController
  async deleteCatalog(catalogId, accountId) {
    return axiosIns.delete(`/catalogs/${catalogId}?accountId=${accountId}`).then(response => response.data)
  },
}
export default CatalogsService
